module.exports = __webpack_public_path__ + "9f3b0d2c6990ea71c79fb06751216e0f.svg";